import type { ActivityItemStatus } from '../components/drawer/transactionTypes/data';

/**
 * Returns the latest status (most recent with a timestamp) from a list.
 * Assumes statuses are in chronological order.
 */
export const getLatestStatus = <T extends ActivityItemStatus>(statuses: T[]): T | undefined => {
  return [...statuses].reverse().find(status => status.timestamp);
};
